import type { IScope } from "angular";
import { finalize } from "rxjs/operators";

import type { IProfileService } from "App/Modules/Auth";

import type { IPartnerUserSite, IProfile, IResponseWithLoading } from "../../../../Models";
import { extendWithLoadingAndFail } from "../../../../Services/ObservableExtensions";

export default class ProfileSitesComponentController {
    public static $inject = ["$scope", "$translate", "mmProfileService"];

    public profile: IProfile;

    public sites: IResponseWithLoading<IPartnerUserSite[]>;

    public subCaption: string;

    constructor(
        private $scope: IScope,
        private $translate: angular.translate.ITranslateService,
        private profileService: IProfileService,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(this.profileService.getSites())
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result: IResponseWithLoading<IPartnerUserSite[]>) => {
                    this.sites = result;
                    if (!result.isLoading && result.data) {
                        this.setSubCaption();
                    }
                },
                (error: IResponseWithLoading<null>) => {
                    this.sites = error;
                },
            );
    }

    private setSubCaption() {
        this.$translate("Entities.Site.NumSitesFormat", { numSites: this.sites.data.length }, "messageformat").then(
            (subCaption) => {
                this.subCaption = subCaption;
            },
        );
    }
}
